import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiHttpService {
  private baseUrl = environment.baseURL;
  httpClient: HttpClient = inject(HttpClient);

  private handleError(error: any): Observable<never> {
    return throwError(() => error);
  }

  /**
   * Resolves a URL by appending it to the base URL and normalizing the slashes.
   * @param url The URL to resolve.
   * @returns The resolved URL.
   */
  private resolveUrl(url: string | URL): string {
    const fullUrl =
      typeof url == 'string' ? `${this.baseUrl}/${url}` : url.toString();
    return fullUrl.replace(/([^:]\/)\/+/g, '$1');
  }

  get<T>(
    url: string | URL,
    options?: {
      context?: HttpContext;
      params?:
        | HttpParams
        | {
            [param: string]:
              | string
              | number
              | boolean
              | ReadonlyArray<string | number | boolean>;
          };
    },
  ): Observable<T> {
    return this.httpClient
      .get<T>(this.resolveUrl(url), options)
      .pipe(catchError(this.handleError));
  }

  post<T>(url: string | URL, body: any): Observable<T> {
    return this.httpClient
      .post<T>(this.resolveUrl(url), body)
      .pipe(catchError(this.handleError));
  }

  put<T>(url: string | URL, body: any): Observable<T> {
    return this.httpClient
      .put<T>(this.resolveUrl(url), body)
      .pipe(catchError(this.handleError));
  }
}

export const FantazHttpClient = ApiHttpService;
